import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Icon } from '@iconify/react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { useResponsive } from 'src/hooks/use-responsive';
import { useMockedUser } from 'src/hooks/use-mocked-user';
// components
import Scrollbar from 'src/components/scrollbar';
import { usePathname } from 'src/routes/hooks';
import { NavSectionVertical } from 'src/components/nav-section';
import { NAV } from 'src/layouts/config-layout';
import { useRiskNavData } from './conifg-nav';

import DashboardSubHeader from '../accounts-management/dashboard-subheader';

// ----------------------------------------------------------------------
export default function NavVertical({ openNav, onCloseNav }) {
  const { user } = useMockedUser();
  const pathname = usePathname();
  const lgUp = useResponsive('up', 'lg');
  const navData = useRiskNavData();
  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const toggleCollapse = () => {
    setCollapsed(!collapsed);
  };

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        '& .simplebar-content': {
          height: 1,
          display: 'flex',
          flexDirection: 'column',
        },
        '& .simplebar-scrollbar:before': {
          background: 'transparent',
        },
        '& .simplebar-track': {
          background: 'transparent !important',
        },
      }}
    >
      {collapsed ? <DashboardSubHeader /> : <DashboardSubHeader Title={'Accounting'} />}
      <NavSectionVertical
        data={navData}
        config={{
          currentRole: user?.role || 'admin',
          collapsed,
        }}
      />
      <Box sx={{ flexGrow: 1 }} />
    </Scrollbar>
  );

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: collapsed ? 108 : NAV.W_VERTICAL,
        transition: 'width 0.3s ease',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {lgUp ? (
        <Stack
          sx={{
            height: 1,
            position: 'fixed',
            width: collapsed ? 108 : NAV.W_VERTICAL,
            borderRight: (theme) => `1px dashed ${theme.palette.divider}`,
            transition: 'width 0.3s ease',
            overflowX: 'hidden',
          }}
        >
          <Tooltip title={collapsed ? 'Expand' : 'Collapse'} placement="right">
            <IconButton
              onClick={toggleCollapse}
              sx={{
                position: 'absolute',
                top: 22,
                left: collapsed ? 65 : 220,
                zIndex: 30,
                backgroundColor: 'white',
                boxShadow: 1,
                transition: 'left 0.3s ease',
              }}
            >
              <Icon
                icon={collapsed ? 'mdi:chevron-right' : 'mdi:chevron-left'}
                width={24}
                height={24}
              />
            </IconButton>
          </Tooltip>
          {renderContent}
        </Stack>
      ) : (
        <Drawer
          open={openNav}
          onClose={onCloseNav}
          PaperProps={{
            sx: {
              width: NAV.W_VERTICAL,
            },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </Box>
  );
}

NavVertical.propTypes = {
  onCloseNav: PropTypes.func,
  openNav: PropTypes.bool,
};
